import { Map } from "immutable";

interface IMutation {
    operation: "insert" | "set" | "remove" | "move";
    index: number;
    value?: Map<string, any> | any;
    destination_index?: number;
}

interface IOperationPayload {
    index: number;
    value?: any;
    destination_index?: number;
}

export const mapToOperation = (mutation: IMutation) => {
    let operationPayload: IOperationPayload;
    switch (mutation.operation) {
        case "insert":
            operationPayload = {
                index: mutation.index,
                value: Map.isMap(mutation.value) ? mutation.value.toJS() : mutation.value,
            };
            break;
        case "set":
            operationPayload = {
                index: mutation.index,
                value: Map.isMap(mutation.value) ? mutation.value.toJS() : mutation.value,
            };
            break;
        case "remove":
            operationPayload = {
                index: mutation.index,
            };
            break;
        case "move":
            /**
             * https://developers.google.com/google-apps/realtime/reference/gapi.drive.realtime.CollaborativeList.html#move
             */
            const { destination_index, index } = mutation;
            operationPayload = {
                destination_index,
                index,
            };
            break;
        default:
    }
    if (!operationPayload) {
        throw new Error(`Operation ${mutation.operation} not implemented`);
    }
    const operation = {
        [mutation.operation]: operationPayload,
    };
    return operation;
};
